import React, { useState } from "react";
import { Card, Form, Row, Col, Image, Button } from "react-bootstrap";
import { useUploadFile } from "../../../../../../api/fileUpload/fileUpload.hooks";

const ExploreSection = ({ data, onUpdate }) => {
  const [isOpen, setIsOpen] = useState(true);
  const { upload, isLoading: isUploading } = useUploadFile();

  const handleChange = (field, value) => {
    onUpdate({ ...data, [field]: value });
  };

  const handleItemChange = (index, field, value) => {
    const updatedItems = [...data.items];
    updatedItems[index] = { ...updatedItems[index], [field]: value };
    handleChange("items", updatedItems);
  };

  const handleFileUpload = async (index, file) => {
    try {
      const res = await upload(file);
      if (res?.url) {
        handleItemChange(index, "image", res.url);
      }
    } catch (err) {
      console.error("File upload failed:", err);
    }
  };

  const addItem = () => {
    const newItem = { name: "", image: "", buttonText: "", link: "" };
    handleChange("items", [...data.items, newItem]);
  };

  const removeItem = (index) => {
    const updatedItems = data.items.filter((_, i) => i !== index);
    handleChange("items", updatedItems);
  };

  return (
    <Card className="mb-4 shadow">
      <Card.Header className="bg-neutral-gray text-dark d-flex justify-content-between align-items-center">
        <h5 className="mb-0 text-dark">Explore Section</h5>
        <Form.Check
          type="checkbox"
          label="Visible"
          checked={data.isVisible}
          onChange={(e) => handleChange('isVisible', e.target.checked)}
          className="mb-0"
        />
      </Card.Header>
      {data.isVisible && (
        <Card.Body>
          <Form.Group className="mb-3">
              <Form.Label>Heading</Form.Label>
              <Form.Control
                type="text"
                value={data.heading || ""}
                onChange={(e) => handleChange('heading', e.target.value)}
                placeholder="Section heading"
              />
            </Form.Group>

            <Form.Group className="mb-3">
              <Form.Label>Description</Form.Label>
              <Form.Control
                as="textarea"
                rows={3}
                value={data.description || ""}
                onChange={(e) => handleChange('description', e.target.value)}
                placeholder="Section description"
              />
            </Form.Group>

            {data.items.map((item, index) => (
            <div key={index} className="mb-4 p-3 border rounded">
              <div className="d-flex justify-content-between align-items-center mb-3">
                <h6>Item {index + 1}</h6>
                {data.items.length > 1 && (
                  <Button
                    variant="outline-danger"
                    size="sm"
                    onClick={() => removeItem(index)}
                  >
                    Remove
                  </Button>
                )}
              </div>
              <Row>
                <Col md={6}>
                  <Form.Group className="mb-3">
                    <Form.Label>Item Name</Form.Label>
                    <Form.Control
                      type="text"
                      value={item.name}
                      onChange={(e) => handleItemChange(index, "name", e.target.value)}
                      placeholder="Enter item name"
                    />
                  </Form.Group>
                  <Form.Group className="mb-3">
                    <Form.Label>Button Text</Form.Label>
                    <Form.Control
                      type="text"
                      value={item.buttonText}
                      onChange={(e) => handleItemChange(index, "buttonText", e.target.value)}
                      placeholder="Enter button text"
                    />
                  </Form.Group>
                </Col>
                <Col md={6}>
                  

                  <Form.Group className="mb-3">
                    <Form.Label>Link</Form.Label>
                    <Form.Control
                      type="text"
                      value={item.link}
                      onChange={(e) => handleItemChange(index, "link", e.target.value)}
                      placeholder="Enter link URL"
                    />
                  </Form.Group>
                </Col>
                <Col md={12}>
                  <Form.Group className="mb-3">
                    <Form.Label>Image</Form.Label>
                    <Form.Control
                      type="file"
                      accept="image/*"
                      onChange={(e) =>
                        e.target.files?.[0] && handleFileUpload(index, e.target.files[0])
                      }
                    />
                    {isUploading && (
                      <div className="text-muted small mt-1">
                        Uploading...
                      </div>
                    )}
                    {item.image && (
                      <div className="mt-2">
                        <Image
                          src={item.image}
                          alt="Preview"
                          thumbnail
                          style={{ maxWidth: "200px" }}
                        />
                      </div>
                    )}
                  </Form.Group>
                </Col>
              </Row>
            </div>
          ))}
          <Button variant="outline-primary" onClick={addItem}>
            Add Item
          </Button>
        </Card.Body>
      )}
    </Card>
  );
};

export default ExploreSection;
